<template>
  <organism-template-detail
    v-if="escalationTemplateDetail"
    :template-detail="escalationTemplateDetail"
    :escalation-timeline-list="escalationTimelineList"
    :fields="fields"
    :items="ticketList"
    :filter-list="filterData"
    @onChangePage="onChangePage"
  ></organism-template-detail>
</template>

<script>
import OrganismTemplateDetail from "@/components/organisms/portal/internal/escalation/OrganismTemplateDetail.vue"
import { getTicketEscalationById } from "@/api/module-1/escalation"
import mixins from "@/mixins"
import { getTicketList } from "@/api/api-module1"

export default {
  name: "TemplateDetail",
  components: { OrganismTemplateDetail },
  mixins: [mixins],
  data() {
    return {
      escalationTemplateDetail: null,
      escalationTimelineList: [],
      fields: [
        {
          key: "status",
          label: "STATUS",
        },
        {
          key: "issueId",
          label: "NTDC ID/Ticket ID",
          class: "text-nowrap",
        },
        {
          key: "createdDate",
          label: "CREATED DATE",
          class: "text-nowrap",
        },
        {
          key: "subject",
          label: "SUBJECT",
          class: "text-nowrap",
        },
        {
          key: "detail",
          label: "DETAIL",
        },
      ],
      ticketList: [],
      filterData: {
        pageNumber: 1,
        totalCount: 0,
      },
    }
  },

  computed: {
    templateId() {
      return this.$route?.params.escalationTemplateId
    },
  },

  async mounted() {
    await this.getEscalationDetail()
    await this.getTicketListByEscalationId()
  },

  methods: {
    convertMinutesToDaysLabel(minuteTotal) {
      if (!minuteTotal) return "0 Minute"

      const mins = minuteTotal % 60
      const hour = Math.floor(minuteTotal / 60)
      const days = Math.floor(hour / 24)
      const hours = hour % 24

      return `${days ? `${days} Days` : ""}${days && hours ? " " : ""}${
        hours ? `${hours} Hours` : ""
      }${hours && mins ? " " : ""}${mins ? `${mins} Minutes` : ""}`
    },

    async getEscalationDetail() {
      this.showLoading(true)
      await getTicketEscalationById(this.templateId)
        .then((response) => {
          this.escalationTemplateDetail = {
            templateId: response.escalationId,
            templateName: response.name,
            status: response.status,
            description: response.description,
            applyAmount: {
              inProgress: response.appliedTicketCount.inProgress,
              all: response.appliedTicketCount.all,
            },
            lastModified: {
              actor: response.updatedUser.fullName,
              role: response.updatedUser.role.roleName,
              datetime: response.updatedAt,
            },
            createdBy: {
              actor: response.createdUser.fullName,
              role: response.createdUser.role.roleName,
              datetime: response.createdAt,
            },
          }

          this.escalationTimelineList = response?.levels.map((item) => {
            return {
              level: item.level,
              escalationTime: this.convertMinutesToDaysLabel(
                item.escalationTimeMinute
              ),
              name: item.name || "-",
              role: item.role || "-",
              contactPhone: item.contactPhone || "-",
              contactEmail: item.contactEmail || "-",
              systemNotification: {
                isEnable: item.enableSystemNotification,
              },
              emailNotification: {
                isEnable: item.enableEmailNotification,
                email: item.email || "-",
              },
              lineNotification: {
                isEnable: item.enableLineNotification,
                lineTokenAlias: item.lineTokenAlias || "-",
              },
            }
          })

          this.escalationTimelineList.sort((a, b) => a.level - b.level)
        })
        .catch(() => {
          this.toastError("Template Not Found")
          this.$router.push({ name: "escalationTemplate" })
        })
        .finally(() => this.showLoading(false))
    },

    onChangePage(filter) {
      this.filterData = filter
      this.getTicketListByEscalationId()
    },

    async getTicketListByEscalationId() {
      const filter = {
        PageSize: 10,
        PageNumber: this.filterData.pageNumber,
        EscalationId: this.templateId,
      }

      await getTicketList(filter).then((response) => {
        this.filterData.totalCount = response?.totalCount
        this.ticketList = response?.data.map((ticket) => {
          return {
            issueId: {
              ticketId: ticket.ticketId,
              ntdcId: ticket.contractId?.toString().padStart(8, "0") || "-",
            },
            status: ticket.status,
            subject: ticket.ticketSubject,
            detail: ticket.ticketDetail,
            createdDate: ticket.openedAt,
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
